angular
    .module('app.controllers')
    .controller('EditTaskCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, notify, api, formValidator, UserService, variables, selectize) {
        // dane
        const TaskModel = api('tasks');
        $scope.about_who = 'client_id';

        $scope.clientOptions = [];
        $scope.interestOptions = [];

        const setupTask = () => {
            $scope.clientOptions = [];
            if ($scope.task.client_id) {
                $scope.clientOptions = [
                    {
                        id: $scope.task.client_id,
                        name: $scope.task.client.name,
                    },
                ];
                $scope.about_who = 'client_id';
            }

            $scope.interestOptions = [];
            if ($scope.task.interest_id) {
                $scope.interestOptions = [
                    {
                        id: $scope.task.interest_id,
                        name: $scope.task.interest.name,
                    },
                ];
                $scope.about_who = 'interest_id';
            }

            $scope.task.date_from = $scope.task.date_from.substr(0, 16);
            $scope.task.date_to = $scope.task.date_to.substr(0, 16);
        };

        $scope.task = {};
        if (0 < $stateParams.id) {
            const info = notify.info($translate.instant('loading'));
            TaskModel.get($stateParams.id).then((response) => {
                $scope.task = response;

                setupTask();

                info.close();
                notify.success($translate.instant('loaded'));
                $rootScope.$broadcast('edit-panel-ready');
            });
        } else {
            $scope.task = {
                id: 0,
                author_id: UserService.getUser().id,
                owner_id: UserService.getUser().id,
                status_id: variables.defaults.task_status_id,
                category_id: variables.defaults.task_category_id,
                date_from: moment().format('YYYY-MM-DD 08:00'),
                date_to: moment().format('YYYY-MM-DD 08:00'),
            };

            if ($stateParams.client) {
                api('clients')
                    .get($stateParams.client)
                    .then((response) => {
                        $scope.clientOptions.push({
                            id: response.id,
                            name: response.name,
                        });
                        $scope.task.client_id = $stateParams.client;
                    });
            }

            if ($stateParams.interest) {
                api('interests')
                    .get($stateParams.interest)
                    .then((response) => {
                        $scope.interestOptions.push({
                            id: response.id,
                            name: response.name,
                        });
                        $scope.task.interest_id = $stateParams.interest;
                    });
            }
        }

        $scope.writePermissions = {
            tasks__write_all: 0,
            tasks__write: [$scope.task.author_id, $scope.task.owner_id],
        };

        $scope.statusOptions = [];
        api('dictionaries/task_status')
            .selectize()
            .then((response) => {
                $scope.statusOptions = response.data;
            });

        $scope.categoryOptions = [];
        api('dictionaries/task_types')
            .selectize()
            .then((response) => {
                $scope.categoryOptions = response.data;
            });

        $scope.userOptions = [];
        api('users')
            .selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } })
            .then((response) => {
                $scope.userOptions = response.data;
            });

        // jedno z dwóch
        $scope.$watch('task.client_id', (n, o) => {
            if (0 < n) {
                $scope.task.interest_id = 0;
            }
        });
        $scope.$watch('task.interest_id', (n, o) => {
            if (0 < n) {
                $scope.task.client_id = 0;
            }
        });

        // autokorekta daty rozpoczęcia/zakończenia
        $scope.$watch('task.date_from', (dateValue) => {
            if (dateValue) {
                const date_from = moment(dateValue);
                const date_to = moment($scope.task.date_to);

                if (date_from.isAfter(date_to)) {
                    $scope.task.date_to = date_from.format('YYYY-MM-DD HH:mm');
                }
            }
        });
        $scope.$watch('task.date_to', (dateValue) => {
            if (dateValue) {
                const date_to = moment(dateValue);
                const date_from = moment($scope.task.date_from);

                if (date_to.isBefore(date_from)) {
                    $scope.task.date_from = date_to.format('YYYY-MM-DD HH:mm');
                }
            }
        });

        // form validation
        const fv = formValidator('#TaskForm', $scope);

        $scope.saveTask = () => {
            if (!fv.isValid()) {
                return;
            }

            const redirectAfterSave = 0 == $scope.task.id;
            const info = notify.info($translate.instant('saving'));
            notify.global(1);

            TaskModel.save($scope.task.id, $scope.task).then((response) => {
                $scope.task = response;

                setupTask();

                TaskModel.clearCache();

                info.close();
                notify.success($translate.instant('saved'));
                notify.global(0);
                $rootScope.$broadcast('edit-panel-ready');

                if (redirectAfterSave) {
                    $state.go('restricted.tasks_edit', { id: $scope.task.id });
                }
            });
        };

        $scope.colorOptions = [
            { value: 'e53935' },
            { value: 'd81b60' },
            { value: '8e24aa' },
            { value: '5e35b1' },
            { value: '3949ab' },
            { value: '1e88e5' },
            { value: '039be5' },
            { value: '0097a7' },
            { value: '00897b' },
            { value: '43a047' },
            { value: '689f38' },
            { value: 'ef6c00' },
            { value: 'f4511e' },
            { value: '6d4c41' },
            { value: '757575' },
            { value: '546e7a' },
        ];
        $scope.selectize_config_colors = selectize.createConfigFromDefault({
            render: {
                item(item, escape) {
                    const color = `#${item.value}`;

                    return `<div class="selectize-colors" style="background: ${color};">&nbsp;</div>`;
                },
                option(item, escape) {
                    const color = `#${item.value}`;

                    return `<div class="selectize-colors" style="background: ${color};">&nbsp;</div>`;
                },
            },
        });
    });
